import { Model } from '@/models/Model';
export class SubjectUserNote extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'SubjectUserNote';
        this.$endpoint = '/subject-user-notes';
        this.$fillable = ['note', 'subject_id'];
    }
}
